import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';

import { BusinessUserInvoiceProvider } from '../../providers/business-user-invoice-handler';
import { BusinessUserInvoiceListPage } from '../../pages/business-user-invoice-list/business-user-invoice-list';

import { Globals } from '../../providers/globals';
import { Utils } from '../../helpers/utils';

/**
 * Generated class for the BusinessInvoiceSearchPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-business-invoice-search',
  templateUrl: 'business-invoice-search.html',
})
export class BusinessInvoiceSearchPage {

  filePath: any;	
	loader: any;
	invoices: any;

  params: any = {
    page: 1,
    size: 25,
    term: '',
    cb: null
  }

  isLoading: boolean = false;
  lastRequestReturnedValues: boolean = false;
  hasData: boolean = false;

  constructor(
  		public navCtrl: NavController, 
		public navParams: NavParams,
		public alertCtrl: AlertController,
		public utils: Utils,
		public businessUserInvoiceProvider: BusinessUserInvoiceProvider,
		public loadingCtrl: LoadingController,
		public globals: Globals) {

		this.filePath = this.globals.fileUrl;
  }

  ionViewDidLoad() {
    this.getUsers(null, true)
  }

  getUsers(ev: any, isPageLoad) {
    // Reset items back to all of the items
    this.resetInvoices();
    // set val to the value of the searchbar
    let val = isPageLoad ? '' : ev.target.value;

    // if the value is an empty string don't filter the items
    if (val || (val.trim() == '' && isPageLoad)) {
      
      let params = {
        page: this.params.page,
        size: this.params.size,
        term: val,

        cb: (invoices)=>{
          this.isLoading = false;

          this.lastRequestReturnedValues = (invoices.length==0) ? false : true;

          this.hasData = (invoices.length == 0 && this.params.page == 1) ? false : true;

          if(this.params.page == 1){

            this.invoices = invoices;  
          }else{
            for (var i = invoices.length - 1; i >= 0; i--) {
              this.invoices.push(invoices[i]);
            }          
          }
        }
      }

      this.businessUserInvoiceProvider.getUsers(params);

    }
  }

  resetInvoices() {
    this.invoices = [];
  }

  viewDetail(user){
    this.navCtrl.push(BusinessUserInvoiceListPage, {user: user});    
  }

}



// WEBPACK FOOTER //
// ./src/pages/business-invoice-search/business-invoice-search.ts